import { ImagePicture } from 'approot/shared/images/images';

import contentSendAvif from './image-content-send.avif';
import contentSendWebp from './image-content-send.webp';
import contentSendPng from './image-content-send.png';

const ImageContentSend = ({
  width,
  altText,
}: {
  width?: number;
  altText?: string;
}) => (
  <ImagePicture
    style={width ? { width, height: width } : undefined}
    altText={altText}
    avif={{ path: contentSendAvif }}
    webp={{ path: contentSendWebp }}
    png={{ path: contentSendPng }}
  />
);

export default ImageContentSend;
